"use strict";

import { addEvent } from "../addEvent/addEvent";

export function slideList(elements = []) {
  Array.from([...elements]).forEach((elm) => {
    slideListInit(elm);
  });
}

function slideListInit(container) {
  if (document.body.classList.contains("mobile")) {
    container.classList.add("mobile-scroll");
    return;
  }

  container.setAttribute("data-mouse-down-at", 0);
  container.setAttribute("data-prev-percentage", 0);
  container.dataset.isScrolling = false;

  let slideElement = container.querySelector(".slide-list");
  if (!slideElement) return;

  const parentRect = container.getBoundingClientRect();

  const listItems = slideElement.querySelectorAll(".slide-list__item");

  const gap = parseFloat(window.getComputedStyle(slideElement).gap) || 0;
  let totalWidth = Array.from(listItems).reduce(
    (acc, item) => acc + item.offsetWidth,
    0
  );
  totalWidth += gap * (listItems.length - 1);
  slideElement.style.width = `${totalWidth}px`;

  const listWidth = totalWidth; //slideElement.scrollWidth;
  const containerWidth = container.offsetWidth;
  const maxDelta = container.offsetWidth;

  if (listWidth <= containerWidth) {
    return;
  }

  const maxNegativePercentage =
    -((listWidth - containerWidth) / listWidth) * 100;

  let isDragging = false;

  function handleMouseDown(event) {
    event.preventDefault();

    isDragging = true;

    let startX = (event.clientX || event.touches[0].clientX) - parentRect.left;
    container.dataset.mouseDownAt = startX;

    if (event.target.tagName === "A") {
      return;
    }
  }

  function handleMouseMove(event) {
    if (!isDragging) return;
    if (container.dataset.mouseDownAt === "0") return;

    const currentX =
      (event.clientX || event.touches[0].clientX) - parentRect.left;
    const mouseDelta = currentX - parseFloat(container.dataset.mouseDownAt);
    const percentage = Math.round((mouseDelta / maxDelta) * 100);

    const nextPercentageUnconstrained =
      parseFloat(container.dataset.prevPercentage) + percentage;

    const nextPercentage = Math.round(
      Math.max(Math.min(nextPercentageUnconstrained, 0), maxNegativePercentage)
    );

    container.dataset.percentage = nextPercentage;

    container.dataset.isScrolling = true;
    slideElement.classList.add("is-scrolling");

    slideElement.animate(
      {
        transform: `translate(${nextPercentage}%, 0%)`,
      },
      { duration: 1200, fill: "forwards" }
    );

    for (const image of slideElement.getElementsByClassName("image")) {
      let nextPercentageImg = (nextPercentage * 100) / maxNegativePercentage;
      image.style.setProperty("--percentageX", `-${nextPercentageImg}%`);

      image.animate(
        {
          objectPosition: `${100 - nextPercentageImg}% center`,
        },
        { duration: 1200, fill: "forwards" }
      );
    }
  }

  function handleMouseUp(event) {
    if (!isDragging) return;
    isDragging = false;

    container.dataset.mouseDownAt = "0";
    container.dataset.prevPercentage = container.dataset.percentage;

    if (container.dataset.isScrolling === "true") {
      event.preventDefault(); // Zatrzymaj domyślną akcję (np. otwieranie linku)
      container.dataset.isScrolling = false;
      slideElement.classList.remove("is-scrolling");
      return false; // Zakończ obsługę zdarzenia
    }
  }

  function handleMouseLeave(event) {
    handleMouseUp(event);
  }

  container.addEventListener("mousedown", handleMouseDown);
  container.addEventListener("mousemove", handleMouseMove);
  container.addEventListener("mouseup", handleMouseUp);
  container.addEventListener("mouseleave", handleMouseLeave);

  container.addEventListener("touchstart", handleMouseDown);
  container.addEventListener("touchmove", handleMouseMove);
  container.addEventListener("touchend", handleMouseUp);
  container.addEventListener("touchcancel", handleMouseLeave);
}
